var exports = {
  "k": "xf0b3b88a--ecd13c--container",
};

module.exports = exports;
